<template>
  <div class="litholam-flatbed-die-cutter">
    <div class="litholam-flatbed-die-cutter-upper">
      <div class="litholam-flatbed-die-cutter-upper__card">
        <div class="icons">
          <div class="icon roll-paper"></div>
          <div class="icon block-paper"></div>
        </div>
        <p class="process-title">Sheeting Roll</p>
        <div class="process-details">
          <p class="detail-item"><span>Speed:</span> 800fpm or 250M/m</p>
          <p><span>Process cost:</span></p>
          <ul>
            <li>$0.51 per MSF</li>
            <li>$0.15 per MSF</li>
          </ul>
        </div>
      </div>

      <div class="litholam-flatbed-die-cutter-upper__card">
        <div class="icons">
          <div class="icon block-paper"></div>
          <div class="icon drops"></div>
          <div class="icon machine"></div>
        </div>
        <p class="process-title">Sheetfed Litho Press</p>
        <div class="process-details">
          <p class="detail-item"><span>Speed:</span> 8,000 sh/hr</p>
          <p class="detail-item"><span>Setup:</span> 45min (5-6 units) <br> Equipment Hourly Rate Included</p>
          <p><span>Process cost:</span></p>
          <ul class="detail-item">
            <li>$14.47 per MSF</li>
            <li>€0.146 per SQM</li>
          </ul>
          <p class="detail-item"><span>Process duration:</span> 2.9hrs</p>
        </div>
      </div>

      <div class="litholam-flatbed-die-cutter-upper__card">
        <div class="icons">
          <div class="icon block-paper"></div>
          <div class="icon gears"></div>
          <div class="icon sheet"></div>
        </div>
        <p class="process-title">Sheetfed Lamination</p>
        <div class="process-details">
          <p class="detail-item"><span>Speed:</span> 300fpm or 90M/m</p>
          <p class="detail-item"><span>Setup:</span> 15min</p>
          <p><span>Process cost:</span></p>
          <ul class="detail-item">
            <li>$9.56 per MSF</li>
            <li>€0.096 per SQM</li>
          </ul>
          <p class="detail-item"><span>Process duration:</span> 3hrs</p>
        </div>
      </div>

      <div class="litholam-flatbed-die-cutter-upper__card">
        <div class="icons">
          <div class="icon sheet"></div>
          <div class="icon box"></div>
        </div>
        <p class="process-title">Flatbed Die Cutter</p>
        <div class="process-details">
          <p class="detail-item"><span>Speed:</span> 50 sh/m</p>
          <p class="detail-item"><span>Setup:</span> 30min</p>
          <p><span>Process cost:</span></p>
          <ul class="detail-item">
            <li>$3.26 per MSF</li>
            <li>€0.033 per SQM</li>
          </ul>
          <p class="detail-item"><span>Process duration:</span> 6hrs</p>
        </div>
      </div>
    </div>
    <div class="litholam-flatbed-die-cutter-lower">
      <div class="first-stat">
        <div class="icon"></div>
        <p><span>100,000</span></p>
        <p style="margin-top: -15px;"><strong>Boxes</strong></p>
      </div>
      <strong>=</strong>
      <div>
        <p class="second-stat"><span>$26.75</span> (per MSF) or <span>€0.269</span> (per SQM)</p>
        <p><span>10.7 Hours</span></p>
      </div>
    </div>
    <p class="footnote">Calculations were performed in $ per MSF, then converted to € per SQM. The conversion was based
      on an exchange
      rate of €1 = $1.069. Liner costs not included in results.</p>
    <div class="lower-sidenote">
      <p class="title-sidenote">DigiFrame</p>
      <p class="subtitle-sidenote">September</p>
      <p class="subtitle-sidenote">100,000 Qty</p>
    </div>
  </div>

</template>

<style lang="scss" scoped>
@import '@/scss/views/why-digital/manufacturing-time.scss';

.litholam-flatbed-die-cutter {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  p {
    margin: 0;
  }

  .litholam-flatbed-die-cutter-upper {
    display: flex;
    gap: 2px;
    text-align: left;
    width: auto;
    max-width: 1000px;

    &__card {
      flex: 1;
      background: transparent;
      padding: 20px 24px;
      border-right: 1px solid $color-blue-light;
    }

    &__card:last-child {
      border-right: none;
    }

    .process-title {
      color: $color_blue_light;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      letter-spacing: -0.667px;
      margin-bottom: 14px;
      width: max-content;
    }

    .process-details {
      color: #fff;
      font-size: 13px;
      line-height: 1.4;
      font-family: $font_light;

      span {
        font-family: $font_default;
      }

      ul {
        padding-left: 24px;
      }

      li::marker {
        color: $color_blue_light;
        font-size: 1.5em;
      }

      li {
        margin: -6px 0px;
      }
    }

    .detail-item {
      margin-bottom: 14px;
    }
  }

  .litholam-flatbed-die-cutter-lower {
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
    padding: 20px;
    background-color: $color_body_two;
    font-size: 24px;
    margin-top: 40px;
    border-radius: 8px;

    span {
      font-size: 36px;
      color: $color-blue-light;
      font-weight: 600;
    }

    .first-stat {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: $color-blue-light;

      .icon {
        background-image: url($cube-icon);
        background-repeat: no-repeat;
        background-size: contain;
        height: 54px;
        width: 54px;
      }
    }

    .second-stat {
      border-bottom: 1px solid $color-blue-light;
    }
  }
}
</style>
